// extracted by mini-css-extract-plugin
export default {"root":"PODg","image":"yn6E","imageIcon":"v4+T"};